export enum EToastMessageActionType {
  ADD = 'ADD',
  REMOVE_ALL = 'REMOVE_ALL',
}
